var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64216 2.95526C4.85187 1.90703 6.39949 1.33103 8.00016 1.33326C11.6822 1.33326 14.6668 4.31793 14.6668 7.99993C14.6668 9.42393 14.2202 10.7439 13.4602 11.8266L11.3335 7.99993H13.3335C13.3336 6.95434 13.0263 5.9318 12.4499 5.05943C11.8735 4.18706 11.0535 3.50336 10.0916 3.09334C9.12978 2.68332 8.06864 2.56506 7.04013 2.75327C6.01163 2.94148 5.06113 3.42786 4.30683 4.15193L3.64216 2.95526ZM12.3582 13.0446C11.1485 14.0928 9.60084 14.6688 8.00016 14.6666C4.31816 14.6666 1.3335 11.6819 1.3335 7.99993C1.3335 6.57593 1.78016 5.25593 2.54016 4.17326L4.66683 7.99993H2.66683C2.66674 9.04551 2.974 10.0681 3.55039 10.9404C4.12678 11.8128 4.94687 12.4965 5.90871 12.9065C6.87054 13.3165 7.93169 13.4348 8.96019 13.2466C9.9887 13.0584 10.9392 12.572 11.6935 11.8479L12.3582 13.0446Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.d4529702.svg";
export { ForwardRef as ReactComponent };